import React, { createContext, useReducer, ReactNode, JSX } from 'react'
import { Notification } from '../../components'
import { initialState, NotificationActionTypes, notificationReducer, NotificationState } from './notificationReducer'

interface NotificationContextType {
  notificationState?: NotificationState
  notificationDispatch?: React.Dispatch<NotificationActionTypes>
}

export const NotificationContext = createContext<NotificationContextType>({ notificationState: initialState })

export const NotificationProvider = (props: { children: ReactNode }): JSX.Element => {
  const [notificationState, notificationDispatch] = useReducer(
    notificationReducer,
    initialState
  )

  return (
    <NotificationContext.Provider value={{ notificationState, notificationDispatch }}>
      {props.children}
      <Notification />
    </NotificationContext.Provider>
  )
}
